<script>
    import Reporter from "../../lib/error.js";
    import { addOrUpdateContributor } from "../../Contributor.svelte";
    import ContributorModel from "../../models/participaid/Contributor.js";
    import { client, gql } from "../../GraphQL.svelte";

    import Dialog from "../Dialog.svelte";
    import Name from "../Name.svelte";
    import Emoji from "../Emoji.svelte";
    import Field from "../form/Field.svelte";
    import TextField from "../form/TextField.svelte";
    import NumberField from "../form/NumberField.svelte";
    import UrlField from "../form/UrlField.svelte";
    //import ImageUploadField from "../form/ImageUploadField.svelte";
    import CloudinaryImageUpload from "../form/CloudinaryImageUpload.svelte";
    import Button from "../form/Button.svelte";
    import {Label} from '@smui/button';
    import Messages from "../form/Messages.svelte";
    import Message from "../form/Message.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import ContributorDropdown from "../form/ContributorDropdown.svelte";
    import Slider from "../form/Slider.svelte";
    import SalaryField from "../form/SalaryField.svelte";
    import ContributorInline from "../participaid/ContributorInline.svelte";
    import Notification from "../Notification.svelte";

    import {Input, Textarea} from '@smui/textfield';
    import Icon from '@smui/textfield/icon/index';
    import HelperText from '@smui/textfield/helper-text/index';
    import {Icon as CommonIcon} from '@smui/common';
    import FloatingLabel from '@smui/floating-label';
    import LineRipple from '@smui/line-ripple';
    import NotchedOutline from '@smui/notched-outline';
    import Tab from '@smui/tab';
    import TabBar from '@smui/tab-bar';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    // whether this dialog should be shown
    export let show = true;
    export let disabled = false;

    // pass the contributor if it exists
    export let user;

    // submission request states
    let errorResult;
    let submitRequest;
    let errorMsg;
    let successMsg;

    let {
        firstName,
        lastName,
        emailAddress,
        linkedInProfileName,
        phoneNumber,
        twitterAccount,
        facebookAccount,
        biography,
        tags,
        color
    } = {...user};

    // register contributor for this project
    function create() {
        submitRequest = client.mutate({
            variables: {
                user: {
                    id: user.id,
                    firstName,
                    lastName,
                    emailAddress,
                    linkedInProfileName,
                    phoneNumber,
                    twitterAccount,
                    facebookAccount,
                    biography,
                    tags,
                    color
                }
            },
            mutation: gql`
                mutation($user: UpdateUserInput!) {
                    updateUser(user: $user) {
                        token
                    }
                }
            `,
        })

        // on success
        .then(res => {
            console.log("[ConfigureUserDialog] successfully created or updated User");
            console.log(res.data);
            dispatch("update", res.data.updateUser);
            dispatch("close");
            errorResult = null;
            errorMsg = null;
            successMsg = "Successfully saved user settings";
        })

        // on error
        .catch(res => {
            console.error(res);
            errorResult = res;
            errorMsg = "There was an error trying to save user settings";
        })
    }

</script>

<Dialog {show} request={submitRequest}>
    <h1>Configure user <Emoji name="pencil2"/></h1>
    <p style="display: flex; flex-direction: row; align-items: center; flex-flow: wrap; justify-content: center;">
        Configure your user settings
    </p>
    <form>
        <Messages>
            {#if errorResult}
                <Message>{JSON.stringify(errorResult)}</Message>
            {/if}
        </Messages>
        <!-- TODO: include avatar here to edit -->
        <Field>
            <TextField
                    bind:value={firstName}
                    fullwidth
                    label="First name"
                    placeholder=""
                    help=""

            />
        </Field>
        <Field>
            <TextField
                    bind:value={lastName}
                    fullwidth
                    label="Last name"
                    placeholder=""
                    help=""

            />
        </Field>
        <Field>
            <TextField
                    bind:value={emailAddress}
                    fullwidth
                    label="Email address"
                    placeholder="you@example.com"
                    help=""

            />
        </Field>
        <Field>
            <TextField
                    bind:value={phoneNumber}
                    fullwidth
                    label="Phone number"
                    placeholder=""
                    help=""

            />
        </Field>
        <Field>
            <TextField
                    bind:value={biography}
                    fullwidth
                    textarea
                    label="Bio"
                    placeholder=""
                    help=""

            />
        </Field>
        <Field>
            <TextField
                    bind:value={tags}
                    fullwidth
                    label="Skills"
                    placeholder="Web design, project management, finance"
                    help=""

            />
        </Field>
    </form>
    <Button id="button-step1" on:click={create} {disabled} style="margin: auto; display: block;">
        <Label>
            Update
        </Label>
    </Button>
</Dialog>

<Notification type="error" message={errorMsg} />
<Notification type="success" message={successMsg} />

<style>
    form {
        margin: 25px 0;
    }

    p {
        text-align: center;
        margin: 25px 0;
    }

    :global(#button-step1) {
        margin: auto;
        //margin-top: 50px;
        display: block;
    }

</style>